"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const TypeCounter_1 = tslib_1.__importDefault(require("./TypeCounter"));
const DefaultAssetCounts = ({ assetCounts }) => {
    const { truck, bus, van, trailer, driver } = assetCounts;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'display-flex' }, { children: [(0, jsx_runtime_1.jsx)(TypeCounter_1.default, { hideOnZero: true, icon: 'truck-baseline', value: truck }), (0, jsx_runtime_1.jsx)(TypeCounter_1.default, { hideOnZero: true, icon: 'trailer-baseline', value: trailer }), (0, jsx_runtime_1.jsx)(TypeCounter_1.default, { hideOnZero: true, icon: 'bus-baseline', value: bus }), (0, jsx_runtime_1.jsx)(TypeCounter_1.default, { hideOnZero: true, icon: 'van-baseline', value: van }), (0, jsx_runtime_1.jsx)(TypeCounter_1.default, { hideOnZero: true, icon: 'driver', value: driver })] })));
};
const TreeSummary = react_1.default.memo(props => {
    const { className, assetCounts, children } = props;
    const classes = (0, classnames_1.default)('TreeSummary', 'display-flex', 'flex-wrap', 'align-items-center', 'column-gap-15', 'row-gap-5', className);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes }, { children: children || (0, jsx_runtime_1.jsx)(DefaultAssetCounts, { assetCounts: assetCounts }) }));
});
TreeSummary.displayName = 'TreeSummary';
TreeSummary.defaultProps = {
    assetCounts: {},
    className: '',
};
TreeSummary.propTypes = {
    assetCounts: prop_types_1.default.shape({
        truck: prop_types_1.default.number,
        trailer: prop_types_1.default.number,
        bus: prop_types_1.default.number,
        van: prop_types_1.default.number,
        driver: prop_types_1.default.number,
    }),
    className: prop_types_1.default.string,
};
exports.default = TreeSummary;
